"use strict";
// Loads Afterpay's script only where a placement is actually rendered. The
// island-entry marker that pulls this in uses load: 'visible', so the request is
// deferred until the placement scrolls into view instead of firing on every page.
const SRC = 'https://js.afterpay.com/afterpay-1.x.js';
if (!document.querySelector(`script[src="${SRC}"]`)) {
    const script = document.createElement('script');
    script.async = true;
    script.src = SRC;
    document.head.appendChild(script);
}
